import type { ProjectCostResult } from '@/api/calculations';

interface ProjectTotalsBarProps {
  projectCost: ProjectCostResult | null;
  isLoading?: boolean;
}

const fmt = (n: number) => n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

export default function ProjectTotalsBar({ projectCost, isLoading }: ProjectTotalsBarProps) {
  if (isLoading || !projectCost) {
    return (
      <div
        className="sticky top-0 z-10 rounded-lg mb-4 px-5 py-3 animate-pulse"
        style={{ backgroundColor: '#1a2a3a', height: '64px' }}
      />
    );
  }

  const { grand_total, subtotal_cost, total_margin } = projectCost;
  const marginPct = grand_total > 0 ? ((total_margin / grand_total) * 100).toFixed(1) : '0';

  const hasPending = projectCost.areas.some((a) =>
    a.line_items.some((li) => li.calculation_deferred)
  );

  return (
    <div
      className="sticky top-0 z-10 rounded-lg mb-4 px-5 py-3 flex items-center justify-between"
      style={{ backgroundColor: '#1a2a3a' }}
    >
      <div className="flex items-baseline gap-8">
        <div>
          <div className="text-[10px] uppercase tracking-wider" style={{ color: '#888' }}>
            Grand Total
          </div>
          <div className="text-xl font-bold" style={{ color: '#2ecc71' }}>
            {fmt(grand_total)}
          </div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-wider" style={{ color: '#888' }}>
            Cost
          </div>
          <div className="text-base" style={{ color: '#ccc' }}>
            {fmt(subtotal_cost)}
          </div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-wider" style={{ color: '#888' }}>
            Margin
          </div>
          <div className="text-base" style={{ color: '#3498db' }}>
            {fmt(total_margin)} ({marginPct}%)
          </div>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-xs" style={{ color: '#888' }}>
          {projectCost.margin_profile_name ?? 'No margin profile'}
        </span>
        {hasPending && (
          <span
            className="text-[10px] font-semibold px-2 py-0.5 rounded"
            style={{ backgroundColor: '#e67e22', color: '#fff' }}
          >
            PENDING
          </span>
        )}
      </div>
    </div>
  );
}
